import { vesselUpdatesConstants } from '../../_constants';
import { vesselUpdatesServices } from '../../_services';
import { alertActions, confirmPromptActions, notificationActions, userActions, } from '../index';

export const vesselUpdatesActions = {
    load,
    getVesselHeaderDetails,
    createVesselHeader,
    createVesselDetails,
    updateVesselDetails,
    deleteDetails,
    deleteHeaders
};

function vesselUpdatesFetching() { return { type: vesselUpdatesConstants.VESSEL_UPDATES_FETCHING } }
function vesselUpdatesFetched() { return { type: vesselUpdatesConstants.VESSEL_UPDATES_FETCHED } }

function vesselUpdatesSubmitting() { return { type: vesselUpdatesConstants.VESSEL_UPDATES_SUBMITTING } }
function vesselUpdatesSubmitted() { return { type: vesselUpdatesConstants.VESSEL_UPDATES_SUBMITTED } }

function load(skip, take, search) {
    return dispatch => {
        dispatch(vesselUpdatesFetching());
        dispatch(userActions.allowLeavePage());
        vesselUpdatesServices.load(skip, take, search)
            .then(
                vesselUpdates => {
                    if (vesselUpdates.length > 0) {
                        dispatch(success(vesselUpdates));
                        dispatch(vesselUpdatesFetched());
                    } else {
                        dispatch(alertActions.warning(vesselUpdates.message))
                        dispatch(vesselUpdatesFetched());
                    }
                },
                error => {
                    dispatch(vesselUpdatesFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(vesselUpdates) { return { type: vesselUpdatesConstants.VESSEL_UPDATES, vesselUpdates } }
}

function getVesselHeaderDetails(Vuid) {
    return dispatch => {
        dispatch(vesselUpdatesFetching());
        dispatch(userActions.allowLeavePage());
        vesselUpdatesServices.getVesselHeaderDetails(Vuid)
            .then(
                vesselHeaderDetails => {
                    dispatch(success(vesselHeaderDetails))
                    dispatch(vesselUpdatesFetched());
                },
                error => {
                    dispatch(vesselUpdatesFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(vesselHeaderDetails) { return { type: vesselUpdatesConstants.GET_VESSEL_HEADER_DETAILS_BY_VUID, vesselHeaderDetails } }
}

// function createVesselHeader(payload, notification) {
function createVesselHeader(payload) {
    return dispatch => {
        dispatch(vesselUpdatesSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselUpdatesServices.createVesselHeader(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselUpdatesSubmitted());
                    // if(notification){
                    // dispatch(notificationActions.CreateNotification(notification));
                    // }
                    dispatch(alertActions.success('Vessel updates added successfully'))
                    window.location.href = '/voyage/vessel_updates/read/' + payload.vuid;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselUpdatesSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function createVesselDetails(payload, index, notification) {
    return dispatch => {
        dispatch(vesselUpdatesSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselUpdatesServices.createVesselDetails(payload)
            .then(
                newVesselDetails => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselUpdatesSubmitted());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success('Vessel updated successfully'));
                    // dispatch(getVesselHeaderDetails(payload.vuid));
                    dispatch(success(newVesselDetails, index));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselUpdatesSubmitted());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(getVesselHeaderDetails(payload.vuid));
                }
            );
    };
    function success(newVesselDetails, index) { return { type: vesselUpdatesConstants.CREATE_VESSEL_DETAILS, newVesselDetails, index } }
}

function updateVesselDetails(payload, id, index, notification) {
    return dispatch => {
        dispatch(vesselUpdatesSubmitting());
        dispatch(userActions.notallowLeavePage());
        vesselUpdatesServices.updateVesselDetails(payload, id)
            .then(
                newVesselDetails => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselUpdatesSubmitted());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success('Vessel updated successfully'));
                    // dispatch(getVesselHeaderDetails(payload.vuid));
                    dispatch(success(newVesselDetails, index));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(vesselUpdatesSubmitted());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(getVesselHeaderDetails(payload.vuid));
                }
            );
    };
    function success(newVesselDetails, index) { return { type: vesselUpdatesConstants.CREATE_VESSEL_DETAILS, newVesselDetails, index } }
}

function deleteDetails(id, uuid, index) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        vesselUpdatesServices.deleteDetails(id)
            .then(
                newVesselDetails => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Vessel updates removed successfully'));
                    // dispatch(getVesselHeaderDetails(uuid));
                    dispatch(success(newVesselDetails, index));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(getVesselHeaderDetails(uuid));
                }
            );
    };
    function success(newVesselDetails, index) { return { type: vesselUpdatesConstants.CREATE_VESSEL_DETAILS, newVesselDetails, index } }
}

function deleteHeaders(id) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        vesselUpdatesServices.deleteHeaders(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Vessel updates deleted successfully'));
                    window.location.href = '/voyage/vessel_updates';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}